import { render, staticRenderFns } from "./MultipleCheckboxComponent.vue?vue&type=template&id=1ca38b22&scoped=true&"
import script from "./MultipleCheckboxComponent.vue?vue&type=script&lang=js&"
export * from "./MultipleCheckboxComponent.vue?vue&type=script&lang=js&"
import style0 from "./MultipleCheckboxComponent.vue?vue&type=style&index=0&id=1ca38b22&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca38b22",
  null
  
)

export default component.exports